<mat-card>
  <app-table
    [columns]="columns"
    [data]="history"
    [dateSearch]="['when']"
    [this]="this"
  ></app-table>
</mat-card>
